/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */
import type { AgencyBranchSummaryResponseDto } from './agencyBranchSummaryResponseDto';
import type { AgencyDtoDescription } from './agencyDtoDescription';
import type { AgencyDtoDisplayName } from './agencyDtoDisplayName';
import type { AgencyDtoLogoUrl } from './agencyDtoLogoUrl';
import type { AgencyDtoSlug } from './agencyDtoSlug';
import type { AgencyProfileLinkResponseDto } from './agencyProfileLinkResponseDto';

export interface AgencyDto {
  id: string;
  name: string;
  /** @nullable */
  displayName: AgencyDtoDisplayName;
  /** @nullable */
  slug: AgencyDtoSlug;
  /** @nullable */
  description: AgencyDtoDescription;
  /** @nullable */
  logoUrl: AgencyDtoLogoUrl;
  isMemberOfZrks: boolean;
  isMemberOfNarks: boolean;
  isMemberOfRealUnia: boolean;
  links: AgencyProfileLinkResponseDto[];
  /** @nullable */
  branch: AgencyBranchSummaryResponseDto | null;
}
